import { useContext, useEffect, useState } from 'react'
import {
  Card,
  CardBody,
  Col,
  Row,
  FormGroup,
  Label,
  Button,
  Form,
} from 'reactstrap'
import { useHistory } from 'react-router-dom'
import { Formik } from 'formik'
import MainContainer from '../../components/modules/containers/MainContainer'
import CustomSelect from '../../components/elements/CustomSelect'
import UserContext from '../../store/userContext'
import { getProjectOptions } from './utils'
import { patientHome } from '../../breadcrumRoutes.js'
import { townshipGroups } from '../../mock-data/roles'

const VisitOptons = () => {
  let history = useHistory()
  let { eachData } = useContext(UserContext)
  let initalValues = {
    type: '',
    project_id: '',
    region_id: '',
  }
  let [projectOptions, setProjectOptions] = useState()

  useEffect(() => {
    
    setProjectOptions(getProjectOptions(eachData))
  }, [setProjectOptions, getProjectOptions])

  const submitData = async (values) => {
    if (values.type === 1) {
      if (eachData.role !== 5) {
        history.push('/add-visit/' + values.project_id)
      } else {
        history.push(
          '/add-visit/' +
            townshipGroups.find(
              (element) => element.id == eachData.township_group_id
            ).name
        )
      }
    } else if (values.type == 2) {
      history.push('/add-visit/REGION?region_id=' + values.region_id)
    }
  }

  return (
    <MainContainer breadcrums={patientHome}>
      <Row className="mt-3">
        <Col md={{ size: 6, offset: 3 }}>
          <Card>
            <CardBody>
              <Formik
                initialValues={initalValues}
                validate={(values) => {
                  const errors = {}
                  if (!values.type) errors.type = '** Required **'
                  else if (
                    values.type == 1 &&
                    eachData.role !== 5 &&
                    !values.project_id
                  )
                    errors.project_id = '** Required **'
                  else if (values.type == 2 && !values.region_id)
                    errors.region_id = '** Required **'
                  return errors
                }}
                onSubmit={(values) => submitData(values)}
              >
                {(formik) => (
                  <Form onSubmit={formik.handleSubmit}>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label>Project / Region</Label>
                          <CustomSelect
                            options={[
                              { value: 1, label: 'Project' },
                              { value: 2, label: 'Region' },
                            ]}
                            onChange={(value) =>
                              formik.setFieldValue('type', value.value)
                            }
                            value={formik.values.type}
                          />
                          <span className="text-danger">
                            {formik.errors.type &&
                              formik.touched.type &&
                              formik.errors.type}
                          </span>
                        </FormGroup>
                      </Col>
                    </Row>
                    {formik.values.type == 1 && eachData.role !== 5 && (
                      <Row className="mt-3">
                        <Col>
                          <FormGroup>
                            <Label>Project</Label>
                            <CustomSelect
                              onChange={(value) =>
                                formik.setFieldValue('project_id', value.value)
                              }
                              value={formik.values.project_id}
                              options={projectOptions}
                            />
                          </FormGroup>
                          <span className="text-danger">
                            {formik.errors.project_id &&
                              formik.touched.project_id &&
                              formik.errors.project_id}
                          </span>
                        </Col>
                      </Row>
                    )}
                    {formik.values.type == 2 && (
                      <Row className="mt-3">
                        <Col>
                          <FormGroup>
                            <Label>Region</Label>
                            <CustomSelect
                              onChange={(value) =>
                                formik.setFieldValue('region_id', value.value)
                              }
                              value={formik.values.region_id}
                              options={[
                                { value: 1, label: 'Mandalay' },
                                { value: 2, label: 'Yangon' },
                                { value: 3, label: 'Magway' },
                                { value: 4, label: 'Southern Shan' },
                                { value: 5, label: 'Northern Shan' },
                                { value: 6, label: 'Sagaing' },
                              ]}
                            />
                          </FormGroup>
                          <span className="text-danger">
                            {formik.errors.region_id &&
                              formik.touched.region_id &&
                              formik.errors.region_id}
                          </span>
                        </Col>
                      </Row>
                    )}

                    <Row className="mt-5 d-flex flex-row justify-content-center head">
                      <Col md={{ size: 4 }}>
                        <Button block className="add-btn" type="submit">
                          Next
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </MainContainer>
  )
}
export default VisitOptons
